import additionalEndorsements from "./additionalEndorsements";
import dispensingWindow from "./dispensingWindow";
class setPrescriptionItemChecks {
  constructor(
    response,
    qty,
    dose,
    prescribedItemId,
    isUpdate,
    currentPatientId,
    prescriptionIncomingId
  ) {
    this.obj = response?.prescriptionItems?.map((value) => {
      return {
        patientId:
          currentPatientId === "" ? response?.patientId : currentPatientId,
        isErd: response?.isErd,
        patientGender: response?.patient?.sex, //not in res
        PrescriptionDate: response?.prescriptionDate,
        prescriptionType: response?.prescriptionType,
        prescriptionId: response?.prescriptionId,
        incomingPrescriptionId:
          response?.prescriptionIncomingId ===
          "00000000-0000-0000-0000-000000000000"
            ? prescriptionIncomingId
            : response?.prescriptionIncomingId,
        spinePrescriptionTypeCode: response.prescriberCode,
        prescriptionTreatmentType:
          response.prescriptionTreatmentType === "Acute"
            ? 0
            : response.prescriptionTreatmentType,
        isEmergencyPrescription: response?.isEmergencyPrescription,
        prescriptionSource: response?.prescriptionSourceType,
        prescribedItemId: value?.prescribedItemId,
        epsLineItemId: value?.epsLineItem,
        drugMatchType: value?.prescribedItem
          ? value.prescribedItem?.drugMatchType
          : 0,
        dispensingWindow: value.dispensingWindow
          ? new dispensingWindow(value.dispensingWindow).obj
          : {},
        isInvalid: value.prescribedItem
          ? value.prescribedItem?.isInvalid
          : false,
        prescriptionItemId: value.prescriptionItemId
          ? value?.prescriptionItemId
          : null,
        quantity:
          isUpdate === true
            ? value.prescriptionItemId === prescribedItemId
              ? qty
              : 0
            : value.quantity
            ? value?.quantity
            : 0,
        isExpired: value.isExpired ? value?.isExpired : false,
        additionalEndorsements:
          value.additionalEndorsements == null
            ? []
            : new additionalEndorsements(value.additionalEndorsements).obj, //array of objects//more  than one prescribes item
        doseText:
          isUpdate === true
            ? value.prescriptionItemId === prescribedItemId
              ? dose
              : ""
            : value.doseText
            ? value?.dosageText
            : value?.dosageText,
        performManualCheck: value.performManualCheck
          ? value?.dosageAutoCheckInfo
          : false,
      };
    });
  }
}

export default setPrescriptionItemChecks;
